package core.cache

data class CacheEntry<T>(
    val data: T,
    val timestamp: Long,
    val ttl: Long = 5 * 60 * 1000 // 5 minutes default
) {
    fun isExpired(): Boolean {
        return (js("Date.now()") as Long) - timestamp > ttl
    }
}

object CacheManager {
    private val cache = mutableMapOf<String, CacheEntry<*>>()
    
    fun <T> get(key: String): T? {
        val entry = cache[key] as? CacheEntry<T>
        if (entry == null || entry.isExpired()) {
            cache.remove(key)
            return null
        }
        console.log("✅ Cache hit: $key")
        return entry.data
    }
    
    fun <T> set(key: String, data: T, ttl: Long = 5 * 60 * 1000) {
        cache[key] = CacheEntry(data, js("Date.now()") as Long, ttl)
        console.log("💾 Cached: $key")
    }
    
    fun invalidate(key: String) {
        cache.remove(key)
        console.log("🗑️ Cache invalidated: $key")
    }
    
    fun invalidatePattern(pattern: String) {
        val keysToRemove = cache.keys.filter { it.startsWith(pattern.removeSuffix("*")) }
        keysToRemove.forEach { cache.remove(it) }
        console.log("🗑️ Cache invalidated pattern: $pattern (${keysToRemove.size} entries)")
    }
    
    fun clear() {
        cache.clear()
        console.log("🗑️ Cache cleared")
    }
}
